import { Injectable } from '@angular/core';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';
import { LanguageDTO, UserNavigation, MobileLinksDTO } from '@signature-it/ngx-generic/models';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import { CommonService } from './common.service';
import { PageNotificationService } from './page-notification';

@Injectable({
    providedIn: 'root'
})

export class MenuNavigationService extends CommonService {

    protected apmUrl = `${this.restUrlsConf.appURL}/menu/account_portal.json`;
    protected nmUrl = `${this.restUrlsConf.appURL}/public/menu/navigation.json`;
    protected amnUrl = `${this.adminBaseUrl}/menu/navigation.json`;
    protected isDam = GenericConfig.isDam;
    protected personalAccountLink = GenericConfig.personalAccountLink;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig,
                protected notifySvc: PageNotificationService) {
        super(http, restUrlsConf, notifySvc);
    }

    getAccountPortalMenu(): Observable<any> {
        return this.http.get(this.apmUrl)
            .pipe(tap((res: HttpResponse<any>) => res, (error: any) => throwError(error)));
    }

    getAdminMenu(): Observable<any> {
        return this.http.get(this.amnUrl)
            .pipe(map((res: HttpResponse<any>) => this.mapAdminMenu(res), (error: any) => throwError(error)));
    }

    getMobileNavigation(lang: LanguageDTO): Observable<MobileLinksDTO[]> {
        return this.http.get(`${this.restUrlsConf.appURL}/public/mobile_links.json?lang=${lang.code}`)
            .pipe(map((res: HttpResponse<any>) =>  {
                const data = res['data'] || [];
                return MobileLinksDTO.createFromArray(data);
            }), catchError( (error: any) => throwError(error)));
    }

    getTopNavigation(name?: string): Observable<any> {
        const nmUrl = (name) ? `${this.nmUrl}?name=${name}`: this.nmUrl;
        return this.http.get(nmUrl)
            .pipe(tap((res: HttpResponse<any>) => res, (error: any) => throwError(error)));
    }

    getUserNavigation(user: IUser): Array<UserNavigation> {
        if(user && this.isDam) {
            return UserNavigation.createFromArray([
                {
                    'name': 'Personal Account',
                    'link': (this.personalAccountLink) ? this.personalAccountLink : '/account/previous-share-list',
                    'icon': 'sli-user'
                }
            ]);
        } else if (user) {
            return UserNavigation.createFromArray([
                {
                    'name': 'Personal Account',
                    'link': (this.personalAccountLink) ? this.personalAccountLink : '/account/dashboard',
                    'icon': 'sli-user'
                }
            ]);
        }
        return [];
    }

    mapAdminMenu(res) {
        let menu =  res && res[0] ? res[0].children : [];
        menu = menu.map(item => {
            delete item.parent;
            item.icon = item['pic'] || 'star';
            return item;
        });
        return menu;
    }

}
